import { ApolloProvider } from '@apollo/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Login } from './components';
import { client } from './graphql';
import { AuthProvider } from './providers';
import { AppRoutes } from './routes';
import { ChargesProvider } from './context';

const App = () => {
    return (
        <AuthProvider>
            {authStatus => {
                if (authStatus === 'authenticated') return <AuthenticatedApp />;
                return <UnauthenticatedApp />;
            }}
        </AuthProvider>
    );
};

const UnauthenticatedApp = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path=":id" element={<Login />} />
                <Route path="*" element={<Login />} />
            </Routes>
        </BrowserRouter>
    );
};

const AuthenticatedApp = () => {
    return (
        <ApolloProvider client={client}>
            <ChargesProvider>
                <BrowserRouter>
                    <AppRoutes />
                </BrowserRouter>
            </ChargesProvider>
        </ApolloProvider>
    );
};

export default App;
